import { get } from 'lodash';
import { useRecordContext } from 'react-admin';

import { ChipsList } from '@sh4res/bo-common/components/ChipsList';

type Props = {
  source: string;
};

export const ChipFieldsList = ({ source }: Props) => {
  const record = useRecordContext();
  const value = get(record, source);

  if (!record || !Array.isArray(value)) {
    return null;
  }

  return <ChipsList list={value} />;
};
